const headers = {
  name: "Registry Sessions",
  components: [
    {
      type: "range",
      name: "date",
      value: {
        start: "",
        end: "",
      },
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Billings",
        path: "/app/billing",
      },
       {
        name: "Returns",
        path: "/app/billing/returns",
      },
      {
        name: "Sessions",
        path: "",
      },
      // {
      //   name: "Quotes",
      //   path: "/app/sales/quotes",
      // },
      // {
      //   name: "Boqs",
      //   path: "/app/sales/boqs",
      // },
    ],
    total: [
      { value: 0, label: "Total" },
      { value: 0, label: "Active" },
      { value: 0, label: "Inactive" },
    ],
  },
};

export default headers;
